<template>
    <div class="container mt-4">
        <form class="" @submit.prevent="handleSubmit">
            <div class="d-flex justify-content-center pt-4" v-if="loading">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ $t('loading') }}...</span>
                </div>
            </div>

            <div class="card shadow-sm mt-4 px-4 py-3 text-center" v-if="sent">
                {{ $t('tours.form_sent') }}
            </div>

            <div class="card booking-form-card shadow-sm" v-if="!loading && !sent">
                <div class="card-header">
                    <span class="icon position-pin-icon"></span>

                    {{ $t('tours.header') }} <span v-if="tour"> - {{ tour.name }}</span>
                </div>

                <div class="card-content px-4 py-3">
                    <div class="row mb-4" v-if="dateFrom != dateTo">
                        <div class="col-12 col-md-6" v-if="dateFrom">
                            <div class="font-weight-bold">{{ $t('tours.date_from') }}</div>

                            <input disabled class="form-control pretty-input" :value="dateFrom">
                        </div>

                        <div class="col-12 col-md-6" v-if="dateTo">
                            <div class="font-weight-bold">{{ $t('tours.date_to') }}</div>

                            <input disabled class="form-control pretty-input" :value="dateTo">
                        </div>
                    </div>

                    <div class="row mb-4" v-else>
                        <div class="col-12 col-md-6" v-if="dateFrom">
                            <div class="font-weight-bold">{{ $t('date') }}</div>

                            <input disabled class="form-control pretty-input" :value="dateFrom">
                        </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-12 col-md-6 font-weight-bold">
                            <div>{{ tour.adults_only?$t('tours.person_count'):$t('tours.adults_count') }}</div>

                            <input type="number" step="1" min="0" max="1000" class="form-control pretty-input" required v-model="adultsCount">
                        </div>

                        <div class="col-12 col-md-6 font-weight-bold" v-if="!tour.adults_only">
                            <div>{{ $t('tours.children_count') }}</div>

                            <input type="number" step="1" min="0" max="1000" class="form-control pretty-input" v-model="childrenCount">
                        </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-12 font-weight-bold">
                            <div>{{ $t('tours.name') }}</div>

                            <input type="text" class="form-control pretty-input" v-model="name">
                        </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-12 col-md-6">
                            <div class="font-weight-bold">{{ $t('tours.email') }}</div>

                            <input type="email" :placeholder="$t('email_example')" class="form-control pretty-input" required v-model="email">
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="font-weight-bold">{{ $t('tours.phone') }}</div>

                            <input type="tel" class="form-control pretty-input" minlength="9" required v-model="phone">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="font-weight-bold">{{ $t('tours.message_content') }}</div>

                            <textarea rows="5" class="form-control pretty-input" v-model="message"></textarea>
                        </div>
                    </div>

                    <div class="row mb-4 mx-2">
                        <consents :consents.sync="consents" class="consents"></consents>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button type="submit" class="btn btn-primary py-2 px-4">{{ $t('tours.submit') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import TourRepository from '@repositories/TourRepository';
    import { mapGetters } from 'vuex';
    import Consents from '@components/Consents';

    export default {
        components: {
            Consents,
        },

        data() {
            return {
                code: this.$route.params.code,
                dateFrom: this.$route.params.dateFrom,
                dateTo: this.$route.params.dateTo,
                loading: false,
                tour: null,
                email: '',
                message: '',
                name: '',
                phone: '',
                sent: false,
                adultsCount: 0,
                childrenCount: 0,
                consents: [],
            };
        },

        computed: {
            ...mapGetters({
                userEmail: 'user/getEmail',
            }),
        },

        created() {
            if (this.code) {
                this.loading = true;
                TourRepository.getTour(this.code).then(({ data }) => {
                    if (data.data) {
                        this.tour = data.data;
                    }

                    this.loading = false;
                });
            }

            this.email = this.userEmail;
        },

        methods: {
            handleSubmit() {
                this.sent = false;

                let checkedConsents = [];
                this.consents.forEach((consent) => {
                    if (consent.checked) {
                        checkedConsents.push(consent.id);
                    }
                });

                TourRepository.sendInquiry({
                    code: this.code,
                    date_from: this.dateFrom,
                    date_to: this.dateTo,
                    adults_count: this.adultsCount,
                    children_count: this.childrenCount,
                    email: this.email,
                    message: this.message,
                    checked_consents: checkedConsents,
                    name: this.name,
                    phone: this.phone,
                    adults_only: this.tour.adults_only,
                })
                    .then((response) => {
                        this.sent = true;
                    })
                    .catch((e) => {
                        console.info(e);
                        this.sent = false;
                    });
            },
        },

    };
</script>

<style scoped>
    .container {
        max-width: 800px;
    }

    .card .card-content * {
        color: #333333;
    }

    button {
        color: #ffffff !important;
        font-size: 1.2rem;
    }

    .consents >>> label {
        font-weight: bold;
    }
</style>
